import { Component, OnInit } from '@angular/core';
import { UserService } from '../core/services/user.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { MatDialog } from '@angular/material/dialog';
import { ScoreDgComponent } from './score-dg/score-dg.component';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'bt-subset',
  templateUrl: './subset.component.html',
  styleUrls: ['./subset.component.scss']
})
export class SubsetComponent implements OnInit {
  loading = true;
  data;
  treeData;


  private _transformer = (node, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name + ' ' + node.family,
      level
      , ...node
    };
  }

  // tslint:disable-next-line: member-ordering
  treeControl = new FlatTreeControl<any>(
    node => node.level, node => node.expandable);

  // tslint:disable-next-line: member-ordering
  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level,
    node => node.expandable,
    node => node.children);

  // tslint:disable-next-line: member-ordering
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  hasChild = (_: number, node: any) => node.expandable;

  constructor(
    private userService: UserService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getChildhoodTree();
  }
  openScoreDialog(data) {
    this.dialog.open(ScoreDgComponent, {
      data
    });
  }
  addUser(data?) {

    this.router.navigate([`/users/add/${data ? data.roleId - 1 : +localStorage.getItem('roleId') - 1}/${data ? data.id :
      +localStorage.getItem('id')}`]);
  }
  editUser(data) {
    this.router.navigate([`/users/edit/${data.id}`]);
  }
  deleteUser(data) {
    this.dialog.open(ConfirmDialogComponent).afterClosed().subscribe(
      res => {
        if (res) {
          this.userService.deleteUser(data.id).subscribe(
            _ => {
              this.getChildhoodTree();
            }
          );
        }
      }
    );
  }
  openPost(type, data) {
    this.router.navigate([`/manage-posts/${type}/${data.id}/${data.roleId}`]);
  }
  getChildhoodTree() {
    this.userService.getChildhoodTree().subscribe(
      res => {
        this.data = res;

        this.createTree();
        this.loading = false;
      }
    );
  }
  createTree() {
    const tempdata = [...this.data];
    this.treeData = tempdata.filter(x => +x.parentId === +localStorage.getItem('id'));
    this.treeData.forEach(element => {
      element.children = tempdata.filter(x => +x.parentId === +element.id);
    });
    this.dataSource.data = this.treeData;


  }

}
